<template>
  <div>
    <div class="card">
      <div class="card__header">
        <h2>Coupon code creation</h2>
        <br/>
        <small>Your account threshold:</small>
        <br/>
        <small>Percentage amount: {{ threshold_percentage }}</small>
        <br/>
        <small>Fix amount: {{ threshold_fix }}</small>
        <div clas="create_new_coupon">
          <br/>
          <button class="btn btn-success" @click="clearFields()">Reset</button>
          <button class="btn btn-primary" @click="orderSearchDialogVisible = true;">Create From Order</button>
        </div>

        <div class="actions">
          <a>
            <i class="zmdi zmdi-check-all"></i>
          </a>
          <a href>
            <i class="zmdi zmdi-trending-up"></i>
          </a>
          <div class="dropdown">
            <a href data-toggle="dropdown">
              <i class="zmdi zmdi-more-vert"></i>
            </a>
            <ul class="dropdown-menu pull-right">
              <li>
                <a href>Change Date Range</a>
              </li>
              <li>
                <a href>Change Graph Type</a>
              </li>
              <li>
                <a href>Other Settings</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="flot-chart-edge">
        <div id="chart-curved-line" class="flot-chart">
          <div class="card__body">
            <div class="form-group">
              <label class="col-md-2 control-label">Coupon Site</label>
              <div class="col-md-4">
                <el-select
                    v-model="couponSite"
                    placeholder="Select"
                    class="form-control form-control"
                    id="couponSite"
                    name="couponSite"
                    v-bind:disabled="id == 0 ? false : true"
                >
                  <el-option
                      v-for="item in sites"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  ></el-option>
                </el-select>
                <i class="form-group__bar"></i>
              </div>
            </div>
            <br/>

            <div class="form-group">
              <label class="col-md-2 control-label">Coupon Code Reason</label>
              <div class="col-md-4">
                <el-select
                    v-model="couponGroup"
                    placeholder="Select"
                    class="form-control form-control"
                    id="couponGroup"
                    name="couponGroup"
                    @change="changeCouponGroup()"
                    v-bind:disabled="id == 0 ? false : true"
                >
                  <el-option
                      v-for="item in couponReasonsPrefixGroups"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  ></el-option>
                </el-select>
                <i class="form-group__bar"></i>
              </div>

              <div class="col-md-4">
                <el-select
                    v-model="couponGroupDetail"
                    placeholder="Select"
                    class="form-control form-control"
                    id="couponGroupDetail"
                    name="couponGroupDetail"
                >
                  <el-option
                      v-for="item in couponReasonsDetailGroups"
                      :key="item"
                      :label="item"
                      :value="item"
                  ></el-option>
                </el-select>
                <i class="form-group__bar"></i>
              </div>
            </div>
            <br/>

            <div class="form-group">
              <label class="col-md-2 control-label">Code</label>
              <div class="col-md-10">
                <textarea
                    class="form-control"
                    placeholder="Coupon code..."
                    v-model="couponCode"
                    v-bind:disabled="id == 0 ? false : true"
                ></textarea>
              </div>
            </div>
            <br/>

            <div class="form-group">
              <label class="col-md-2 control-label">Coupon type</label>
              <div class="col-md-4">
                <el-select
                    v-model="couponType"
                    placeholder="Select"
                    class="form-control form-control"
                    id="couponType"
                    name="couponType"
                    v-bind:disabled="id == 0 ? false : true"
                >
                  <el-option
                      v-for="item in types"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  ></el-option>
                </el-select>
                <i class="form-group__bar"></i>
              </div>
              <label class="col-md-2 control-label">Coupon Amount</label>
              <div class="col-md-2">
                <input
                    type="number"
                    class="form-control"
                    pattern="^[0-9]+$"
                    v-model="amount"
                    id="coupon_amount"
                    v-bind:disabled="id == 0 ? false : true"
                />
              </div>
              <div class="col-md-2">
                <span class="control-label">{{ couponType == 'fixed' ? '$' : '%' }}</span>
              </div>
            </div>
            <br/>

            <div class="form-group">
              <label class="col-md-2 control-label">Family</label>
              <div class="col-md-4">
                <el-select
                    v-model="trackerPrefix"
                    placeholder="Select"
                    class="form-control form-control"
                    id="trackerPrefix"
                    name="trackerPrefix"
                    @change="changeTrackerPrefix()"
                    v-bind:disabled="id == 0 ? false : true"
                >
                  <el-option
                      v-for="item in trackerPrefixGroups"
                      :key="item"
                      :label="item"
                      :value="item"
                  ></el-option>
                </el-select>
                <i class="form-group__bar"></i>
              </div>

              <div class="col-md-4">
                <el-select
                    v-model="trackerContent"
                    placeholder="Select"
                    class="form-control form-control"
                    id="trackerContent"
                    name="trackerContent"
                    v-bind:disabled="id == 0 ? false : true"
                >
                  <el-option
                      v-for="item in trackerContentGroups"
                      :key="item"
                      :label="item"
                      :value="item"
                  ></el-option>
                </el-select>
                <i class="form-group__bar"></i>
              </div>
            </div>
            <br/>

            <div class="form-group">
              <label class="col-md-2 control-label">Size</label>
              <div class="col-md-4">
                <el-select
                    v-model="itemSize"
                    placeholder="Select"
                    class="form-control form-control"
                    id="itemSize"
                    name="itemSize"
                    v-bind:disabled="id == 0 ? false : true"
                >
                  <el-option v-for="item in itemSizeGroups" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <i class="form-group__bar"></i>
              </div>
            </div>
            <br/>

            <div class="form-group">
              <label class="col-md-2 control-label">Factory</label>
              <div class="col-md-4">
                <el-select
                    v-model="itemFactory"
                    placeholder="Select"
                    class="form-control form-control"
                    id="itemFactory"
                    name="itemFactory"
                >
                  <el-option
                      v-for="item in itemFactoryGroups"
                      :key="item"
                      :label="item"
                      :value="item"
                  ></el-option>
                </el-select>
                <i class="form-group__bar"></i>
              </div>
            </div>
            <br/>

            <div class="form-group">
              <label class="col-md-2 control-label required">Source of purchase</label>
              <div class="col-md-4">
                <el-select
                    v-model="supplierName"
                    placeholder="Select"
                    class="form-control form-control"
                    id="supplierName"
                    name="supplierName"
                    v-bind:disabled="id == 0 ? false : true"
                >
                  <el-option
                      v-for="item in supplierNameGroups"
                      :key="item"
                      :label="item"
                      :value="item"
                  ></el-option>
                </el-select>
                <i class="form-group__bar"></i>
              </div>
            </div>
            <br/>

            <div class="form-group">
              <label class="col-md-2 control-label required">Authorized Reseller</label>
              <div class="col-md-4">
                <el-select
                    v-model="authorizedReseller"
                    placeholder="Select"
                    class="form-control form-control"
                    id="authorizedReseller"
                    name="authorizedReseller"
                    v-bind:disabled="id!==0"
                >
                  <el-option
                      v-for="item in authorizedResellerOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                  ></el-option>
                </el-select>
                <i class="form-group__bar"></i>
              </div>
            </div>
            <br/>

            <div class="form-group">
              <label class="col-md-2 control-label required">Name of retailer</label>
              <div class="col-md-4">
                <textarea
                    class="form-control"
                    placeholder="Name of retailer......"
                    v-model="retailerName"
                    v-bind:disabled="id == 0 ? false : true"
                ></textarea>
              </div>
            </div>
            <br/>

            <div class="form-group">
              <label class="col-md-2 control-label">Shopify SKU *saxx.com only</label>
              <div class="col-md-4">
                <textarea
                    class="form-control"
                    placeholder="sxbb10f_xyz"
                    v-model="productSku"
                    v-bind:disabled="id == 0 ? false : true"
                ></textarea>
              </div>
            </div>
            <br/>

            <div class="form-group">
              <label class="col-md-2 control-label required">Customer First Name</label>
              <div class="col-md-4">
                <textarea
                    class="form-control"
                    placeholder="Customer first name......"
                    v-model="customerFirstName"
                ></textarea>
              </div>
              <label class="col-md-2 control-label required">Customer Last Name</label>
              <div class="col-md-4">
                <textarea
                    class="form-control"
                    placeholder="Customer last name......"
                    v-model="customerLastName"
                    @change="updateCustomerLastName()"
                    v-bind:disabled="id == 0 ? false : true"
                ></textarea>
              </div>
            </div>
            <br/>

            <div class="form-group">
              <label class="col-md-2 control-label required">Customer Email</label>
              <div class="col-md-4">
                <textarea
                    class="form-control"
                    placeholder="Customer email......"
                    v-model="customerEmail"
                    v-bind:disabled="id == 0 ? false : true"
                ></textarea>
              </div>
              <label class="col-md-2 control-label">Customer Phone</label>
              <div class="col-md-4">
                <textarea
                    class="form-control"
                    placeholder="Customer phone......"
                    v-model="customerPhone"
                    v-bind:disabled="id == 0 ? false : true"
                ></textarea>
              </div>
            </div>
            <br/>

            <div class="form-group">
              <label class="col-md-2 control-label required">Order number</label>
              <div class="col-md-4">
                <textarea
                    class="form-control"
                    placeholder="Order number......"
                    v-model="orderNumber"
                ></textarea>
              </div>
            </div>
            <br/>

            <div class="form-group">
              <label class="col-md-2 control-label">Image URL</label>
              <div class="col-md-10">
                <textarea class="form-control" placeholder="Image URL......" v-model="imgUrl"></textarea>
              </div>
            </div>
            <br/>

            <div class="form-group">
              <label class="col-md-2 control-label">Additional comment</label>
              <div class="col-md-10">
                <textarea
                    class="form-control"
                    placeholder="Additional comment......"
                    v-model="reason"
                    v-bind:disabled="id == 0 ? false : true"
                ></textarea>
              </div>
            </div>
            <br/>

            <div class="form-group">
              <div class="col-md-12">
                <button class="btn btn-success" @click="submitCoupon" :disabled="disableCreateBtn">Submit</button>
                <button class="btn btn-danger">
                  <router-link to="/coupon-management">Cancel</router-link>
                </button>
              </div>
            </div>

            <br/>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        title="Search Order"
        :visible.sync="orderSearchDialogVisible"
        :destroy-on-close="true"
        :center="true"
        width="33%"
    >
      <el-form v-model="orderSearchForm">
        <div class="form-group">
          <el-row>
            <el-col :span=4>
              <label class="control-label">Site</label>
            </el-col>
            <el-col :span=20>
              <el-select
                  v-model="orderSearchForm.orderSiteSearch"
                  placeholder="Select"
                  class="form-control form-control"
                  id="orderSiteSearch"
                  name="orderSiteSearch"
              >
                <el-option
                    v-for="item in sites"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span=4>
              <label class="control-label">Order ID</label>
            </el-col>
            <el-col :span=20>
              <el-input placeholder="Please input" v-model="orderSearchForm.orderNumberSearch" @keyup.enter.native="searchOrder"></el-input>
            </el-col>
          </el-row>
          <el-row type="flex" justify="end" style="margin-bottom: 0">
            <el-button type="primary" :disabled="loadingSearch" @click="searchOrder">Search</el-button>
          </el-row>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
        :visible.sync="orderCouponDialogVisible"
        :destroy-on-close="true"
        :center="true"
        width="66%"
    >
      <h4 slot="title">{{orderDiscountForm.order.order_name}}</h4>
      <el-form v-model="orderDiscountForm">
        <div class="form-group">
          <h4 class="control-label">Order Items</h4>
          <el-table
              :data="orderDiscountForm.order.items"
              style="width: 100%"
          >
            <el-table-column
                label="Product">
              <template slot-scope="scope">{{ `${scope.row.title}` + (scope.row.variant_title ? ` - ${scope.row.variant_title}` : ``) }}</template>
            </el-table-column>
            <el-table-column
                property="sku"
                label="SKU"
            >
            </el-table-column>
            <el-table-column
                label="Unit Price"
            >
              <template slot-scope="scope">${{ parseFloat(scope.row.unit_price).toFixed(2) }}</template>
            </el-table-column>
            <el-table-column
                property="quantity"
                label="Qty Ordered"
            >
            </el-table-column>
            <el-table-column
              label="Quantity"
            >
              <template slot-scope="scope">
                <el-input-number v-model="orderDiscountForm.items[scope.row.sku]" :min="0" :max="scope.row.quantity" @change="calculateCouponAmount">
                </el-input-number>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <h4 class="control-label">Coupon Type</h4>
        <el-form-item>
          <el-col :span="4">
            <el-select
                v-model="orderDiscountForm.couponType"
                placeholder="Select"
                class="form-control form-control"
                @change="calculateCouponAmount"
            >
              <el-option
                  v-for="item in types"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-input
                type="number"
                class="form-control"
                pattern="^[0-9]+$"
                v-model="orderDiscountForm.couponAmount"
            >
              <span slot="suffix" style="position:absolute;bottom:0;right:3px;font-size:2rem;">{{ orderDiscountForm.couponType === 'fixed' ? '$' : '%' }}</span>
            </el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <el-row slot="footer" type="flex" justify="end" style="margin-bottom: 0">
        <el-button type="primary" @click="applyOrder">Submit</el-button>
      </el-row>
    </el-dialog>
    <el-dialog
      title="Customer Coupon History"
      :visible.sync="customerHistoryDialogVisible"
      width="50%"
      :center="true"
    >
      <p>This customer has the following historical data, please review:</p>
      <el-table
          :data="this.customerHistoryData"
          style="width: 100%"
      >
        <el-table-column
            property="label"
            width="200"
        >
        </el-table-column>
        <el-table-column
            property="value"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.label === 'Discount Types'" v-html="scope.row.value"></div>
            <div v-else>{{ scope.row.value }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-row style="margin-bottom:0;">
          <el-col :span="4">
            <a target="_blank" :href="`/coupon-management?search=${encodeURIComponent(this.customerEmail)}`"><el-button type="primary">View Coupons</el-button></a>
          </el-col>
          <el-col :span="20" class="text-right">
            <el-button @click="customerHistoryDialogVisible = false">Cancel</el-button>
            <el-button type="primary" @click="saveCoupon" :disabled="disableCreateBtn">Confirm</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import {Decimal} from 'decimal.js';
import axios, {RepositoryError} from "../../repositories";
import {notify} from '../../utils';
import {ORDER_DISCOUNT_WARNING_THRESHOLD} from "../../lang/en/constants";
import SaxxCheckbox from "../forms/SaxxCheckbox.vue";

export default {
  components: {SaxxCheckbox},
  mounted() {
    this.getThreshold();
    this.getCouponConfig();

    var paramId = this.$route.query.id;

    if (typeof paramId == "undefined") {
      this.id = 0;
    } else {
      this.id = paramId;
      this.loadCouponCode(this.id);
    }

    this.$route.params.id = 0;
  },
  data() {
    return {
      disableCreateBtn:false,
      orderSearchDialogVisible: false,
      orderCouponDialogVisible: false,
      customerHistoryDialogVisible: false,
      sites: [
        {
          value: "usa",
          label: "USA"
        },
        {
          value: "ca",
          label: "Canada"
        }
      ],
      types: [
        {
          value: "fixed",
          label: "Fixed Amount"
        },
        {
          value: "percentage",
          label: "Percentage Discount"
        }
      ],
      id: 0,
      couponConfig: [],
      itemSizeGroups: [],
      itemFactoryGroups: [],
      supplierNameGroups: [],
      couponReasonsPrefixGroups: [],
      couponReasonsDetailGroups: [],
      trackerPrefixGroups: [],
      trackerContentGroups: [],
      authorizedResellerOptions: ['Y', 'N', 'N/A'],
      couponGroup: "",
      couponGroupDetail: "",
      trackerPrefix: "",
      trackerContent: "",
      couponSite: "usa",
      couponCode: "",
      itemSize: "",
      itemFactory: "",
      couponType: "fixed",
      amount: 0,
      typeSymbol: "%",
      customerFirstName: "",
      customerLastName: "",
      customerEmail: "",
      customerPhone: "",
      supplierName: "",
      authorizedReseller: "",
      retailerName: "",
      productSku: "",
      orderNumber: "",
      imgUrl: "",
      reason: "",
      threshold_fix: 0,
      threshold_percentage: 0,
      orderSearchForm: {
        orderSiteSearch: "usa",
        orderNumberSearch: ""
      },
      orderDiscountForm: {
        order: {},
        items: {},
        couponType: 'fixed',
        couponAmount: 0
      },
      customerHistory: {
        "order_count": 0,
        "total_discounts": 0,
        "approved_discounts": 0,
        "total_amount": "0.00",
        "discount_types": {}
      },
      loadingSearch: false
    };
  },
  computed: {
    ...mapState({auth: state => state.auth}),
    customerHistoryData: function() {
      return [
        {label: 'Number of Orders', value: this.customerHistory.order_count},
        {label: 'Total Discounts', value: this.customerHistory.total_discounts},
        {label: 'Approved Discounts', value: this.customerHistory.approved_discounts},
        {label: 'Discount Types', value: _.map(this.customerHistory.discount_types, (num, type) => `<div>${type}: ${num}</div>`).join('')},
        {label: 'Total Fixed Amount', value: '$' + this.customerHistory.total_amount.toString()}
      ];
    }
  },
  methods: {
    updateCustomerLastName() {
      const customerLastNameString = this.customerLastName
          .trim()
          .slice(0, 3)
          .toUpperCase();
      this.couponCode =
          this.couponGroup +
          this.generateYearMonthString() +
          customerLastNameString +
          "1";
    },
    getThreshold() {
      const user = this.auth.user;
      const fixed_amount = user.thresholds.find(threshold => threshold.type === 'coupon_fixed');
      const percentage_amount = user.thresholds.find(threshold => threshold.type === 'coupon_percentage');
      if (!fixed_amount || !percentage_amount) {
        throw new Error('Missing threshold limit for coupon creation! Contact IT to have this setup!');
      }

      this.threshold_fix = fixed_amount.limit;
      this.threshold_percentage = percentage_amount.limit;
    },
    async getCouponConfig() {
      try {
        const res = await axios.get("/discounts/get-coupon-config");

        this.couponConfig = res.data;
        this.setCouponConfig();
      } catch (err) {
        if (err instanceof RepositoryError) {
          return;
        }

        throw err;
      }
    },
    setCouponConfig() {
      // set coupon code reason
      this.couponReasonsPrefixGroups = this.couponConfig["couponGroup"];
      this.couponGroup = this.couponGroup || this.couponReasonsPrefixGroups[0]["value"];

      // set coupon code reason detail
      var key = this.couponGroup;
      this.couponReasonsDetailGroups = this.couponConfig["couponGroupDetail"][
          key
          ];
      this.couponGroupDetail = this.couponGroupDetail || this.couponReasonsDetailGroups[0];

      // set code prefix
      if(!this.id) {
        this.couponCode = this.couponGroup + this.generateYearMonthString();
      }
      // set family
      this.trackerPrefixGroups = this.couponConfig["guaranteeTracker"];

      // set family detail
      /*
       * var key = this.trackerPrefix == '2N1' || this.trackerPrefix == 'LOUNGEWEAR' ? this.trackerPrefix : 'other';
       *
       * Note (Hans): The above logic should never have been implemented like this.
       * Customer service needs a quick fix, so I'm not going to re-architect this,
       * but I have created a Jira ticket for this.
       *
       *   https://nolimits.atlassian.net/browse/EP-774
       */
      var key = "other";
      this.trackerContentGroups = this.couponConfig["guaranteeTrackerDetail"][
          key
          ];

      // set size
      this.itemSizeGroups = this.couponConfig["size"];

      // set factory
      this.itemFactoryGroups = this.couponConfig["factory"];

      // set source of purchase
      this.supplierNameGroups = this.couponConfig["supplier"];
    },
    async getGuaranteeTracker() {
      try {
        const res = await axios.get("/discounts/guarantee-tracker");
        const guaranteeTracker = res.data;

        this.trackerPrefixGroups = Object.keys(guaranteeTracker);
        this.trackerPrefix = this.trackerPrefixGroups[0];
        this.trackerContentGroups = guaranteeTracker[this.trackerPrefixGroups[0]];
        this.trackerContent = this.trackerContentGroups[0];
      } catch (err) {
        if (err instanceof RepositoryError) {
          return;
        }

        throw err;
      }
    },
    changeTrackerPrefix() {
      this.trackerContentGroups = this.couponConfig["guaranteeTrackerDetail"][
      this.trackerPrefix || "OTHER"
          ];
      this.trackerContent = this.trackerContentGroups[0];
    },
    changeCouponGroup() {
      this.couponCode = this.couponGroup + this.generateYearMonthString();
      var key = this.couponGroup;
      this.couponReasonsDetailGroups = this.couponConfig["couponGroupDetail"][
          key
          ];
      this.couponGroupDetail = this.couponReasonsDetailGroups[0];
      if(this.customerLastName) {
        this.updateCustomerLastName();
      }
    },
    generateYearMonthString() {
      var month = (new Date().getMonth() + 1).toString();
      var monthExpend = ("0" + month).slice(-2);
      var yearLastTwo = new Date()
          .getFullYear()
          .toString()
          .substr(-2);
      var yearMonthString = yearLastTwo + monthExpend;
      return yearMonthString;
    },
    async submitCoupon() {
      const amount = new Decimal(this.amount);
      const supplier = this.supplierName;
      const authorized_reseller = this.authorizedReseller;
      const retailer_name = this.retailerName;
      const customer_first_name = this.customerFirstName;
      const customer_last_name = this.customerLastName;
      const customer_email = this.customerEmail;
      const order_number = this.orderNumber;

      const requiredFields = {
        "Source of purchase": supplier,
        "Authorized Reseller": authorized_reseller,
        "Retailer Name": retailer_name,
        "Customer First Name": customer_first_name,
        "Customer Last Name": customer_last_name,
        "Customer Email": customer_email,
        "Order Number": order_number,
        "Amount": this.amount
      }

      const emptyFields = _.pickBy(requiredFields, f => _.isEmpty(_.trim(f)))

      if (amount.lte(0)) {
        this.popUpBox("Coupon amount is required", "Coupon amount is required and must be a number greater than 0", "warning");
        return;
      }

      if (!_.isEmpty(emptyFields)) {
        this.popUpBox(
            "The following field(s) are required",
            _.keys(emptyFields).join(', '),
            "warning"
        );
        return;
      }

      try {
        const email = encodeURIComponent(customer_email);
        await axios.get(`/customers/history?email=${email}`).then((res) => {
          this.customerHistory = res.data;
          if(res.data.total_discounts >= ORDER_DISCOUNT_WARNING_THRESHOLD) {
            this.customerHistoryDialogVisible = true;
          } else {
            this.saveCoupon();
          }
        }).catch((err) => {
          notify(err, 'warning');
        });
      } catch (err) {
        if (err instanceof RepositoryError) {
          return;
        }

        if (err.response && err.response.data.errors) {
          this.popUpBox("Coupon application submission fail", err.response.data.errors, "error");
          return;
        }

        throw err;
      }
    },
    async saveCoupon() {
      this.disableCreateBtn = true;
      try {
        const data = {
          id: this.id,
          country: this.couponSite,
          code_type: this.trackerPrefix + "/" + this.trackerContent,
          group_name: this.couponGroup,
          group_detail: this.couponGroupDetail,
          code: this.couponCode,
          type: this.couponType,
          amount: this.amount,
          customer_first_name: this.customerFirstName,
          customer_last_name: this.customerLastName,
          customer_email: this.customerEmail,
          customer_phone: this.customerPhone,
          authorized_reseller: this.authorizedReseller,
          size: this.itemSize,
          factory: this.itemFactory,
          supplier: this.supplierName,
          retailer_name: this.retailerName,
          product_sku: this.productSku,
          order_number: this.orderNumber,
          img_url: this.imgUrl,
          reason: this.reason,
        }

        await axios.post("/discounts/store", data).then((res) => {
          const {state, message, needEmailApprove} = res.data;
          this.customerHistoryDialogVisible = false;
          if (needEmailApprove) {
            this.popUpBox("Coupon code creation pending approval", message, "success");
          } else {
            this.popUpBox("Coupon code created successfully", message, "success");
          }
          this.$router.push({name: 'coupon-management'});
        }).catch((err) => {
          notify(err, 'error');
        }).finally(() => {
          this.disableCreateBtn = false;
        });
      } catch (err) {
        if (err instanceof RepositoryError) {
          return;
        }

        if (err.response && err.response.data.errors) {
          this.popUpBox("Coupon application submission fail", err.response.data.errors, "error");
          return;
        }

        throw err;
      }
      this.disableCreateBtn = false;
    },
    searchOrder(event) {
      event.preventDefault();
      if(this.loadingSearch) {
        return;
      }
      this.loadingSearch = true;
      axios.get("/orders", {
        params: {
          sales_channel: "shopify_" + this.orderSearchForm.orderSiteSearch,
          sales_channel_reference: this.orderSearchForm.orderNumberSearch,
        }
      }).then((res) => {
        const order = res.data;
        this.orderCouponDialogVisible = true;
        this.orderSearchDialogVisible = false;
        this.orderDiscountForm.order = order;
        this.orderDiscountForm.items = {};
        this.orderDiscountForm.couponAmount = 0;
        this.orderDiscountForm.couponType = 'fixed';
      }).catch((error) => {
        notify(error, 'warning');
      }).finally(() => {
        this.loadingSearch = false;
      });
    },
    clearFields() {
      this.couponGroup = "";
      this.couponGroupDetail = "";
      this.trackerPrefix = "";
      this.trackerContent = "";
      this.couponSite = "usa";
      this.couponCode = "";
      this.itemSize = "";
      this.itemFactory = "";
      this.couponType = "fixed";
      this.amount = 0;
      this.typeSymbol = "%";
      this.customerFirstName = "";
      this.customerLastName = "";
      this.customerEmail = "";
      this.customerPhone = "";
      this.supplierName = "";
      this.retailerName = "";
      this.authorizedReseller = "";
      this.productSku = "";
      this.orderNumber = "";
      this.imgUrl = "";
      this.reason = "";
      this.id = 0;
    },
    async popUpBox(header, body, type) {
      try {
        await this.$alert(body, header, {
          confirmButtonText: 'OK',
        });
      } catch {
        // Ignore cancel
        return;
      }
    },
    async loadCouponCode(id) {
      try {
        const res = await axios.get("/discounts/single", {
          params: {id}
        });

        const data = res.data.data;

        this.couponGroup = data[0].group_name;
        this.couponGroupDetail = data[0].group_detail;

        let family = data[0].code_type;
        family = family.split("/");
        this.trackerPrefix = family[0];
        this.trackerContent = family[1];

        this.couponSite = data[0].country;
        this.couponCode = data[0].code;
        this.itemSize = data[0].size;
        this.itemFactory = data[0].factory;
        this.couponType = data[0].type;
        this.amount = data[0].amount;

        if (data[0].type == "fixed") {
          this.typeSymbol = "$";
        } else {
          this.typeSymbol = "%";
        }

        this.isReadOnly = "readonly";
        this.customerFirstName = data[0].customer_first_name;
        this.customerLastName = data[0].customer_last_name;
        this.customerEmail = data[0].customer_email;
        this.customerPhone = data[0].customer_phone;
        this.supplierName = data[0].supplier;
        this.authorizedReseller = data[0].authorized_reseller;
        this.retailerName = data[0].retailer_name;
        this.productSku = data[0].product_sku;
        this.orderNumber = data[0].order_number;
        this.imgUrl = data[0].img_url;
        this.reason = data[0].reason;
      } catch (err) {
        if (err instanceof RepositoryError) {
          return;
        }

        throw err;
      }
    },
    calculateCouponAmount() {
      if(this.orderDiscountForm.couponType === 'fixed') {
        let amount = 0;
        const orderItems = this.orderDiscountForm.order.items;
        _.forOwn(this.orderDiscountForm.items, function(quantity, sku) {
          const item = _.find(orderItems, function(item) {
            return item.sku === sku;
          });
          amount += item.unit_price * (quantity || 0);
        })
        this.orderDiscountForm.couponAmount = amount.toFixed(2);
      }
    },
    applyOrder() {
      this.couponSite = this.orderSearchForm.orderSiteSearch;
      this.orderNumber = this.orderSearchForm.orderNumberSearch;
      this.customerFirstName = this.orderDiscountForm.order.customer.first_name;
      this.customerLastName = this.orderDiscountForm.order.customer.last_name;
      this.customerEmail = this.orderDiscountForm.order.email;
      this.customerPhone = this.orderDiscountForm.order.phone;
      this.couponType = this.orderDiscountForm.couponType;
      this.amount = this.orderDiscountForm.couponAmount;
      this.supplierName = 'SAXX.com';
      this.authorizedReseller = 'Y';
      this.retailerName = 'SAXX';
      this.productSku = Object.keys(_.pickBy(this.orderDiscountForm.items, (i) => i > 0)).join(', ')
      this.orderCouponDialogVisible = false;
      this.updateCustomerLastName();
    }
  },
};
</script>